import { useParams } from 'react-router';
import formats from '../utils/formats';
import React from 'react';
import List from './List';
import Menu from './Menu';

export default function Fork(props) {
    const { restaurant } = props;

    const { type } = useParams();

    return formats.shouldShowList(restaurant.timetables, restaurant.token, restaurant.has_orders, type) ?
        <List restaurant={restaurant}></List> :
        <Menu restaurant={restaurant}></Menu>;
}
